import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/Request';
import Modal from '../../components/Modal';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import ExitButton from '../../components/ExitButton';
import TopBackButton from '../../components/BackButton/TopBackButton';
import RadioComponent from '../../components/RadioComponent';
import dataLayer from '../../utils/data-layer';

const SELECTOR_WRAPPER = '.p-school-onboarding';
const SELECTOR_MODAL = '#js-school-onboarding-modal';

const SELECTOR_SPLASH = '.p-school-onboarding-splash';
const SELECTOR_SPLASH_WRAPPER = '.schoolOnboardingSplash-wrapper';		
const SELECTOR_SPLASH_NEXT = '.p-school-onboarding-splash-next';
const SELECTOR_SPLASH_ACTION = '.p-school-onboarding-splash-action';

const SELECTOR_NURSERY = '.p-school-onboarding-nursery';
const SELECTOR_NURSERY_QUESTION = '.p-school-onboarding-nursery-question';
const SELECTOR_NURSERY_NEXT = '.p-school-onboarding-nursery-next';
const SELECTOR_NURSERY_BACK_CONTAINER = '.p-school-onboarding-nursery-back-container';
const SELECTOR_NURSERY_EXIT_CONTAINER = '.p-school-onboarding-nursery-exit-container';

const SELECTOR_CONFIRMATION = '.p-school-onboarding-confirmation';
const SELECTOR_CONFIRMATION_CONFIRM_BUTTON = '.p-school-onboarding-confirmation-confirm';
const SELECTOR_CONFIRMATION_BACK_CONTAINER = '.p-school-onboarding-confirmation-back-container';
const SELECTOR_CONFIRMATION_EXIT_CONTAINER = '.p-school-onboarding-confirmation-exit-container';

const SELECTOR_SUCCESS = '.p-school-onboarding-success';
const SELECTOR_SUCCESS_BUTTON = '.p-school-onboarding-success--button';

const SELECTOR_STEP = '.p-school-onboarding-step';
const SELECTOR_QUESTION = '.p-school-onboarding-questions';
const SELECTOR_STEP_NEXT = '.p-school-onboarding-step-next';

const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

const IS_LOCAL = false;

const ROLES_SKIP_NURSERY = ['Early Years Practitioner', 'Further Education Staff'];
class SchoolOnboarding {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		this.formElementsList = {};
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.schoolOnboardingModalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);

		this.schoolOnboardingSplashWrapper = SelectorEngine.findOne(SELECTOR_SPLASH_WRAPPER, this._wrapper);
		this.schoolOnboardingSplash = SelectorEngine.findOne(SELECTOR_SPLASH, this.schoolOnboardingSplashWrapper);
		this.schoolOnboardingSplashNext = SelectorEngine.findOne(SELECTOR_SPLASH_NEXT, this.schoolOnboardingSplash);

		this.schoolOnboardingSplashActionEl = SelectorEngine.findOne(SELECTOR_SPLASH_ACTION, this.schoolOnboardingSplashWrapper);
		this.splashExitButton = new ExitButton(this.schoolOnboardingSplashActionEl, {
			classPrefix: 'p-school-onboarding-splash',
			buttonLabel: 'Exit',
			exitButtonClasses: 'p-school-onboarding-splash-exit'
		});
		this.schoolOnboardingSplashActionEl.innerHTML = this.splashExitButton.markup();
		this.schoolOnboardingSplashExitEl = SelectorEngine.findOne('.p-school-onboarding-splash-exit', this.schoolOnboardingSplashActionEl);

		this.schoolOnboardingNursery = SelectorEngine.findOne(SELECTOR_NURSERY, this._wrapper);
		this.schoolOnboardingNurseryQuestion = SelectorEngine.findOne(SELECTOR_NURSERY_QUESTION, this._wrapper);
		this.schoolOnboardingNurseryNext = SelectorEngine.findOne(SELECTOR_NURSERY_NEXT, this._wrapper);

		const nurseryBackContainer = SelectorEngine.findOne(SELECTOR_NURSERY_BACK_CONTAINER, this._wrapper);
		this.nurseryBackButton = new TopBackButton(nurseryBackContainer, { classPrefix: 'p-school-onboarding-nursery' });
		nurseryBackContainer.innerHTML = this.nurseryBackButton.markup();
		this.schoolOnboardingNurseryBack = SelectorEngine.findOne('.p-school-onboarding-nursery__form-back-button', nurseryBackContainer);

		const nurseryExitContainer = SelectorEngine.findOne(SELECTOR_NURSERY_EXIT_CONTAINER, this._wrapper);
		this.nurseryExitButton = new ExitButton(nurseryExitContainer, {
			classPrefix: 'p-school-onboarding-nursery',
			buttonLabel: 'Exit',
			exitButtonClasses: 'p-school-onboarding-nursery-exit'
		});
		nurseryExitContainer.innerHTML = this.nurseryExitButton.markup();
		this.schoolOnboardingNurseryExit = SelectorEngine.findOne('.p-school-onboarding-nursery-exit', nurseryExitContainer);

		this.schoolOnboardingConfirmation = SelectorEngine.findOne(SELECTOR_CONFIRMATION, this._wrapper);
		this.schoolOnboardingConfirmButton = SelectorEngine.findOne(
			SELECTOR_CONFIRMATION_CONFIRM_BUTTON,
			this.schoolOnboardingConfirmation
		);

		const confirmBackContainer = SelectorEngine.findOne(SELECTOR_CONFIRMATION_BACK_CONTAINER, this.schoolOnboardingConfirmation);
		this.confirmBackButton = new TopBackButton(confirmBackContainer, { classPrefix: 'p-school-onboarding-confirmation' });
		confirmBackContainer.innerHTML = this.confirmBackButton.markup();
		this.schoolOnboardingConfirmationBack = SelectorEngine.findOne('.p-school-onboarding-confirmation__form-back-button', confirmBackContainer);

		const confirmExitContainer = SelectorEngine.findOne(SELECTOR_CONFIRMATION_EXIT_CONTAINER, this.schoolOnboardingConfirmation);
		this.confirmExitButton = new ExitButton(confirmExitContainer, {
			classPrefix: 'p-school-onboarding-confirmation',
			buttonLabel: 'Exit',
			exitButtonClasses: 'p-school-onboarding-confirmation-exit'
		});
		confirmExitContainer.innerHTML = this.confirmExitButton.markup();
		this.schoolOnboardingConfirmationExit = SelectorEngine.findOne('.p-school-onboarding-confirmation-exit', confirmExitContainer);

		this.schoolOnboardingStep = SelectorEngine.findOne(SELECTOR_STEP, this._wrapper);
		
		this.schoolOnboardingQuestion = SelectorEngine.findOne(SELECTOR_QUESTION, this.schoolOnboardingStep);
		this.schoolOnboardingStepNext = SelectorEngine.findOne(SELECTOR_STEP_NEXT, this.schoolOnboardingStep);

		this.schoolOnboardingSuccess = SelectorEngine.findOne(SELECTOR_SUCCESS, this._wrapper);
		this.schoolOnboardingSuccessButton = SelectorEngine.findOne(SELECTOR_SUCCESS_BUTTON, this.schoolOnboardingSuccess);

		this.schoolOnboardingModal = new Modal(this.schoolOnboardingModalElement, { backdrop: 'static' });
		this.schoolOnboardingModal.isEscapeEventEnable = false;

		this.schoolOnboardingModal.show();

		EventHandler.on(this.schoolOnboardingSplashNext, CLICK_EVENT, () => {
			this.fetchSchoolOnboardingSteps();
		});

		EventHandler.on(this.schoolOnboardingSplashExitEl, CLICK_EVENT, () => {
			this.schoolOnboardingModal.hide();
		});

		EventHandler.on(this.schoolOnboardingSuccessButton, CLICK_EVENT, () => {
			this.schoolOnboardingModal.hide();
		});

		EventHandler.on(this.schoolOnboardingNurseryBack, CLICK_EVENT, () => {
			this.schoolOnboardingNursery.classList.add(HIDDEN_CLASS);
			this.schoolOnboardingStep.classList.remove(HIDDEN_CLASS);
			if (this.formGenerator._currentStep === this.formGenerator.totalSteps) {
				this.formGenerator.enableSubmitButton();
			}
		});

		EventHandler.on(this.schoolOnboardingNurseryExit, CLICK_EVENT, () => {
			this.formGenerator?.unload();
			this.schoolOnboardingModal.hide();
		});

		EventHandler.on(this.schoolOnboardingNurseryNext, CLICK_EVENT, () => {
			if (!this.nurseryRadioComponent?.validate()) {
				return;
			}

			const nurseryAnswer = this.nurseryRadioComponent.value;
			this.answerList = {
				...this.answerList,
				[nurseryAnswer.fieldName]: nurseryAnswer.value
			};

			this.schoolOnboardingNursery.classList.add(HIDDEN_CLASS);
			this.showConfirmationSection();
			this.pushStepToDataLayer(4);
		});

		EventHandler.on(this.schoolOnboardingConfirmationBack, CLICK_EVENT, () => {
			this.schoolOnboardingConfirmation.classList.add(HIDDEN_CLASS);
			this.schoolOnboardingConfirmButton.disabled = false;

			if (this.shouldShowNurserySection()) {
				this.schoolOnboardingNursery.classList.remove(HIDDEN_CLASS);
			} else {
				this.schoolOnboardingStep.classList.remove(HIDDEN_CLASS);
				this.formGenerator.enableSubmitButton();
			}
		});

		EventHandler.on(this.schoolOnboardingConfirmationExit, CLICK_EVENT, () => {
			this.formGenerator?.unload();
			this.schoolOnboardingModal.hide();
		});
	}
	showSuccessPage() {
		this.schoolOnboardingConfirmation.classList.add(HIDDEN_CLASS);
		this.schoolOnboardingSuccess.classList.remove(HIDDEN_CLASS);
		this.pushStepToDataLayer(5);
	}
	initNurseryQuestion() {
		this.nurseryRadioComponent = new RadioComponent(this.schoolOnboardingNurseryQuestion, {
			data: {
				id: 'nursery',
				fieldName: 'hasNursery',
				questionPrefix: 'Does your school',
				question: 'Have a nursery or would you like to see early years content?',
				errorMessage: 'Please select an option to proceed',
				options: [
					{ id: 0, label: 'Yes' },
					{ id: 1, label: 'No' }
				]
			}
		});

		this.nurseryRadioComponent.onChange(() => {
			this.schoolOnboardingNurseryNext.disabled = false;
		});

		this.schoolOnboardingNurseryNext.disabled = true;
	}
	shouldShowNurserySection() {
		return !ROLES_SKIP_NURSERY.includes(this.answerList?.user);
	}

	showConfirmationSection() {
		this.schoolOnboardingConfirmation.classList.remove(HIDDEN_CLASS);
	}

	showNurserySection() {
		if (!this.shouldShowNurserySection()) {
			this.showConfirmationSection();
			return;
		}

		this.schoolOnboardingNursery.classList.remove(HIDDEN_CLASS);

		if (!this.nurseryRadioComponent) {
			this.initNurseryQuestion();
		} else if (this.nurseryRadioComponent.value) {
			this.schoolOnboardingNurseryNext.disabled = false;
		}
	}
	initiateFormGenerator(stepsData) {
		this.schoolOnboardingSplashWrapper.classList.add(HIDDEN_CLASS);
		this.schoolOnboardingStep.classList.remove(HIDDEN_CLASS);

		this.formGenerator = new FormGenerator(this.schoolOnboardingQuestion, {
			questions: stepsData,
			totalSteps: 3,
			hasSeparator: false,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-new-blue',
			isBackButtonEnabled: true,
			isExitButtonEnabled: true,
			exitButtonHandler: () => {
				this.formGenerator?.unload();
				this.schoolOnboardingModal.hide();
			},
			backButtonHandlerFirstStep: () => {
				this.schoolOnboardingSplashWrapper.classList.remove(HIDDEN_CLASS);
				this.schoolOnboardingStep.classList.add(HIDDEN_CLASS);
			}
		});
		this.formGenerator.onChange((answers) => {
			this.schoolOnboardingStep.classList.add(HIDDEN_CLASS);
			this.prepareRequestObject(answers);
			this.showNurserySection();
		});

		this.formGenerator.onStepChange(() => {
			const currentStep = this.formGenerator._currentStep - 1;
			this.pushStepToDataLayer(currentStep);
		});

		EventHandler.on(this.schoolOnboardingConfirmButton, CLICK_EVENT, () => {
			const currentStep = this.formGenerator._currentStep
			this.pushStepToDataLayer(currentStep);
			this.schoolOnboardingConfirmButton.disabled = true;
			this.saveSchoolOnboardingSteps(this.answerList);
		});

		this.pushStepToDataLayer(0);
	}

	pushStepToDataLayer(currentStep) {
		try {
			const stepMap = {
				0: "School onboarding started",
				1: "Describe yourself",
				2: "Location",
				3: "Free training interest",
				4: "Nursery / early years content",
				5: "School onboarding submitted successfully"
			};
		
			const stepCompleted = stepMap[currentStep];
		
			dataLayer.push({
				event: "school_onboarding",
				stepCompleted
			});
		} 
		catch (error) {
		  console.error(error.message);
		}
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					source: ['LTA Youth Tennis'],
					...this.answerList,
					...formatObject
				};
			}
		}
	}
	async fetchSchoolOnboardingSteps() {
		try {
			const url = '/api/teachermembership/steps';
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}
	async saveSchoolOnboardingSteps(requestObject) {
		try {
			const url = '/api/teachermembership/SaveTeacherOnboardingDetails';
			const response = await Request.post(url, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { Success, error } = response;
			if (Success) {
				this.showSuccessPage();
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}
}

const globalSchoolOnboarding = new SchoolOnboarding();
export default globalSchoolOnboarding;
